import { ConfirmModalActionProps } from '../../components';
import { useModal, HIDE_CONFIRM, SHOW_CONFIRM } from './useModal';

let resolveCallback: (result: boolean) => void;

function useConfirm() {
	const { state: confirmState, dispatch } = useModal();

	const onConfirm = () => {
		closeConfirm();
		resolveCallback(true);
	};

	const onCancel = () => {
		closeConfirm();
		resolveCallback(false);
	};
	const confirm = (
		title: string,
		message = '',
		{
			confirmProps,
			cancelProps,
		}: {
			confirmProps?: ConfirmModalActionProps;
			cancelProps?: ConfirmModalActionProps;
		} = {},
	) => {
		setTimeout(
			() =>
				dispatch({
					type: SHOW_CONFIRM,
					payload: {
						title,
						message,
						submitAction: onConfirm,
						confirmProps,
						cancelProps,
					},
				}),
			100,
		);

		return new Promise((res) => {
			resolveCallback = res;
		});
	};

	const closeConfirm = () => {
		dispatch({
			type: HIDE_CONFIRM,
		});
	};

	return { confirm, onConfirm, onCancel, confirmState };
}

export { useConfirm };
